module.exports = __webpack_public_path__ + "static/media/front_03.0e0219ed.png";